export default (element, styles) => {
    element.style.cssText = Object.keys(styles).map(function (style) {
        return style + ": " + styles[style] + " !important;"
    }).join(" ");
};